const { core } = window.SIMBAR;
export const SPECIAL_PERMISSIONS = core.special_permissions;
